import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseLanguage[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Language/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios.get(url, { params: params }).toOptionalMapped((x) => x.data.languages);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	languages: ResponseLanguage[];
};

export type ResponseLanguage = {
	id: string;
	name: string;
	cultureCode: string;
};
